import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const LEFT_DESKTOP_COL_WIDTH = '466px';

export const Content = styled.div`
  padding-top: 40px;

  ${media.lg`
    display: flex;
  `}
`;

export const HeadingColumn = styled.h2`
  display: none;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.headerFont};
  font-weight: normal;
  color: ${({ theme }) => theme.sectionTitleColour};

  ${media.lg`
    display: inline-block;
    margin: 0 10px 0 0;
    padding: 0 20px;
    flex-shrink: 0;
    width: ${LEFT_DESKTOP_COL_WIDTH};
  `}
`;

export const Description = styled.div`
  font-size: 16px;
  line-height: 22px;
  max-width: 740px;

  ${media.xl`
    line-height: 23px;
  `}
`;
